var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-development"},[_c('div',[_vm._v("In development")]),_c('loader',{attrs:{"size":"s"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }